<template>
    <div>
        <lightbox :activateCommand="'show_comment_lightbox'" :deactivateCommand="'close_comment_lightbox'" customClass="bg-color-white">
            <sms-checker  :phone_nr="phone_nr" :user_name="user_name" :dsgvo="dsgvo" :checkerParent="'comment'" :success="'comment'"/>
        </lightbox>
    <lightbox :activateCommand="'show_blacklist_lightbox'" :deactivateCommand="'close_blacklist_lightbox'" customClass="bg-color-white">
      <h2>Diese Handynummer wurde gesperrt und kann keine Nachrichten mehr verschicken.</h2>
      <button class="btn btn-primary mt4" @click="EBusEmit('close_blacklist_lightbox')">OK</button>
    </lightbox>
    <div class="col-12 p2 py3 mb3 border-box commenting-form bg-color-lightpink" style="box-shadow: 0 8px 14px 0 rgba(0,0,0,0.1)" :class="{'comment-form-expand': msg_text !== '' || user_name !== '' || phone_nr !== '' || dsgvo == true || receive_newsletter == true || expandForm}">
        <div class="flex align-baseline mx1">
        <p class="mr2 mb1 bold"></p>
        </div>
        <div class="relative mb3">
            <textarea   @focus="expandForm = true" @blur="expandForm = false" ref="commentInput" rows=1 class="n8-input comment-textarea" v-model="msg_text" placeholder="Schreibe einen Kommentar..." :class="{ error: not_filled_msg_text }"/>
             <span class="floating-label comment-float-label" style="max-width: 100%;"></span>
        </div>
        <div class="md-flex">
          <div class="relative mb2 md-col-6 col-12">
              <input @focus="expandForm = true" @blur="expandForm = false" required class="n8-input" v-model="user_name" :class="{ error: not_filled_user_name }"/>
              <span class="floating-label">Username*</span>
          </div>
          <div class="mx2"></div>
          <div class="relative mb2 md-col-6 col-12">
              <input @focus="expandForm = true" @blur="expandForm = false" required class="n8-input"  v-model="phone_nr" :class="{ error: not_filled_phone_nr }"/>
              <span class="floating-label">Handynummer*</span>
          </div>
        </div>
        <div class="md-flex">
            <div class="flex align-middle mb2 mt3 md-col-6 mr3">
                <input class="checkbox-input mr2" type="checkbox" v-model="dsgvo">
                <label class="pointer"  :class="{ error: not_filled_dsgvo }">Ich akzeptiere die Datenschutzbedingungen*</label>
            </div>
            <div class="flex align-middle mb2 mt3 md-col-6">
                <input class="checkbox-input mr2" type="checkbox" v-model="receive_newsletter">
                <label class="pointer">Ja, ich möchte den SMS-Newsletter abonnieren</label>
            </div>
        </div>
        <div v-if="!allIsValidated" class="error-msg mb2">Bitte fülle alle Pflichtelder aus.</div>
        <button class="btn btn-primary mt2" @click="validateInput()">Abschicken</button>
    </div>
    </div>
</template>
<script>

import GeneralLightbox from './GeneralLightbox.vue';
import { EventBus } from '../event-bus.js';
import SMSChcker from './SMSChecker.vue';
import axios from 'axios';

export default {
    name: "CommentForm",
    data() {
        return {
        user_name: '',
        phone_nr: '',
        msg_text: '',
        dsgvo: false,
        receive_newsletter: false,

        not_filled_msg_text: false,
        not_filled_phone_nr: false,
        not_filled_user_name: false,
        not_filled_dsgvo: false,

        allIsValidated: true,
        expandForm: false,

        session: {},
        };
    },
    props: {
        imgid: String
    },
    components: {
        'lightbox': GeneralLightbox,
        'sms-checker': SMSChcker,
    },
    created(){
        EventBus.$on('sendSession_Component', (payload) => {
        console.log('Received Session from App')
        console.log(payload)
        this.session = payload.session
        })
        EventBus.$on('sendUser_Component', (payload) => {
            console.log('Received User from App')
            console.log(payload)
            this.user_name = payload.user.user_name;
            this.phone_nr = payload.user.phone_nr;
            this.dsgvo = payload.user.dsgvo;
        });
        EventBus.$on('clear_comment', () => {
            this.msg_text = '';
        })
    },
    mounted(){
        console.log('Component Initialized, requesting Session')
        EventBus.$emit('requestSession_Component');
        EventBus.$emit('requestUser_Component');
    },
    methods: {
        EBusEmit(command){
            EventBus.$emit(command)
        },
        validateInput(){
            this.allIsValidated = true;
            
            this.not_filled_msg_text = false;
            this.not_filled_phone_nr = false;
            this.not_filled_user_name = false;
            this.not_filled_dsgvo = false;

            if(this.msg_text == ''){
                this.allIsValidated = false;
                this.not_filled_msg_text = true;
            }
            if(this.phone_nr == ''){
                this.allIsValidated = false;
                this.not_filled_phone_nr = true;
            }
            if(this.user_name == ''){
                this.allIsValidated = false;
                this.not_filled_user_name = true;
            }
            if(this.dsgvo == false){
                this.allIsValidated = false;
                this.not_filled_dsgvo = true;
            }
            if(this.allIsValidated == true){
                    //send form data
                    console.log('All is validated')
                    // let that = this;
                    let url =  'https://bilder.nachtschicht-schortens.de/public-api/set/comments/json';
                    let data = {};
                    data.images_id = this.imgid
                    data.comment = this.msg_text;
                    data.mobilephone = this.phone_nr;
                    data.name = this.user_name;
                    data.newsletteroptin = this.receive_newsletter;
                    axios.post(url, data)
                    .then(response => {
                        console.log('Response from Comment Call:')
                        console.log(response);  
                        if(response.data.isValidated == false && response.data.isBlacklisted == false){
                            console.log('User not validated. Opening SMSChecker...')
                            EventBus.$emit('sendSession_not_validated', {
                                'validation_crypt': response.data.validation_crypt,
                                'validation_id': response.data.validation_id, 
                                'validation_object': response.data.validation_object 
                            });
                            EventBus.$emit('show_comment_lightbox');
                        }
                        if(response.data.isValidated == true){
                            console.log('User is validated. Everything is fine.')
                            this.msg_text = '';
                            // EventBus.$emit('show_comment_sent_lightbox')
                            console.log('Comment Call successful Sending Validation Session to App:')
                            EventBus.$emit('send_validation', {
                                'validation_crypt': response.data.validation_crypt,
                                'validation_id': response.data.validation_id, 
                                'validation_object': response.data.validation_object 
                            });
                            EventBus.$emit('send_user', {
                                'user_name': this.user_name,
                                'phone_nr': this.phone_nr,
                                'dsgvo': this.dsgvo
                            });
                                EventBus.$emit('reload_comments');
                        }
                        if(response.data.isBlacklisted == true){
                            console.log('User is Blacklisted. GTFO OF HERE')
                            EventBus.$emit('show_blacklist_lightbox')
                        }
})
                    .catch(function (error) {
                        console.log(error)
                    });
            }
            },
    }
}
</script>
<style>

</style>